import { Title } from '@mantine/core'

export const Header = ({ text }) => {
  return (
    <Title
      className="front-header"
      styles={{
        root: {
          borderBottom: "3px solid #404040",
          color: "white",
          textAlign: "left",
        }
      }}>
      {text}
    </Title>
  )
}